// logica condivisa tra ChatThread e MessagePreview

const soloCifre = value => String(value || '').replace(/\D/g, '');

// i messaggi del cliente arrivano dal webhook con from = wa_id del contatto;
// quelli inviati da noi hanno from = numero del nostro account
export function isOutgoing(message, contact) {
	const from = soloCifre(message && message.from);
	const cliente = soloCifre(contact);
	if (!from) return !(message && message.to);
	return from !== cliente;
}

export function statusIcon(status) {
	switch (status) {
		case 'read':
			return { icon: 'mdi-check-all', color: '#53bdeb', label: 'Letto' };
		case 'delivered':
			return { icon: 'mdi-check-all', color: '#8696a0', label: 'Consegnato' };
		case 'failed':
			return { icon: 'mdi-alert-circle-outline', color: 'error', label: 'Non inviato' };
		case 'sent':
			return { icon: 'mdi-check', color: '#8696a0', label: 'Inviato' };
		default:
			return { icon: 'mdi-clock-outline', color: '#8696a0', label: 'In attesa' };
	}
}

export function typeIcon(type) {
	switch (type) {
		case 'image':
			return 'mdi-camera';
		case 'video':
			return 'mdi-video';
		case 'audio':
			return 'mdi-microphone';
		case 'document':
			return 'mdi-file-document-outline';
		case 'template':
			return 'mdi-text-box-outline';
		default:
			return '';
	}
}

export function previewText(message) {
	if (!message) return '';
	switch (message.type) {
		case 'text':
			return (message.text && message.text.body) || '';
		case 'image':
			return (message.image && message.image.caption) || 'Foto';
		case 'video':
			return (message.video && message.video.caption) || 'Video';
		case 'audio':
			return 'Audio';
		case 'document':
			return (message.document && message.document.filename) || 'Documento';
		case 'template':
			return 'Template: ' + ((message.template && message.template.name) || '');
		default:
			return message.type || '';
	}
}

// timestamp WhatsApp in secondi (a volte stringa)
export function toDate(timestamp) {
	const n = parseInt(timestamp, 10);
	return isNaN(n) ? null : new Date(n * 1000);
}
